/**
 * Builds and downloads a CSV file.
 *
 * Cells that begin with =, +, - or @ are prefixed with an apostrophe. Spreadsheet
 * programs run such a cell as a formula, and several columns exported from the
 * portal hold text typed into public forms, so a name like `=HYPERLINK(...)` would
 * otherwise execute on the machine of whoever opens the file. A leading tab or
 * carriage return is treated the same way.
 */

function escapeCell(value: unknown): string {
  let text = value == null ? '' : String(value);
  // A phone number such as +1 (555) 010-0100 starts with + but can only ever be
  // arithmetic, so it is left alone rather than shown with a stray apostrophe.
  const looksLikePhone = /^\+?[\d\s().-]+$/.test(text);
  if (/^[=+\-@\t\r]/.test(text) && !looksLikePhone) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildCsv(headers: string[], rows: unknown[][]): string {
  return [headers, ...rows].map((line) => line.map(escapeCell).join(',')).join('\r\n');
}

/** Saves text as a file in the browser. The byte-order mark makes Excel read UTF-8 correctly. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
